export default __webpack_public_path__ + "static/media/representative-match-oq-logo.8426ee29.png";